import MapCard from "./MapCard";

export default MapCard;
